import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { ChevronLeft } from '../../../assets/icons'
import { BackTitle } from '../../../pages/private/EmergencyRoom/styled'
import useIsMobile from '../../../hooks/useIsMobile'

const BackPageHeader = ({
	onBack,
	title,
	showBack = true,
	hideBackOnMobile = true,
	gap = '12px',
	marginBottom = '0',
	padding = '0',
	className
}) => {
	const isMobile = useIsMobile()
	const shouldShowBack = showBack && typeof onBack === 'function' && (!hideBackOnMobile || !isMobile)

	return (
		<Header className={className} style={{ gap, marginBottom, padding }}>
			{shouldShowBack && (
				<BackTitle m={'0'} onClick={onBack}>
					<ChevronLeft size={8} /> Volver
				</BackTitle>
			)}
			{typeof title === 'string' ? <DefaultTitle>{title}</DefaultTitle> : title}
		</Header>
	)
}

BackPageHeader.propTypes = {
	onBack: PropTypes.func,
	title: PropTypes.node.isRequired,
	showBack: PropTypes.bool,
	hideBackOnMobile: PropTypes.bool,
	gap: PropTypes.string,
	marginBottom: PropTypes.string,
	padding: PropTypes.string,
	className: PropTypes.string
}

const Header = styled.div`
	display: flex;
	align-items: flex-start;
	flex-direction: column;
`

const DefaultTitle = styled.h1`
	font-size: 28px;
	font-weight: 600;
	margin: 0;
	color: ${props => props.theme.colors.text.titleText};

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		font-size: 24px;
	}
`

export default BackPageHeader